const rnd = (a, b) => a + Math.random() * (b - a);

export const fx = {
  spark: (list, x, y, color = "#FFF7AE") => list.push({ k: "spark", x, y, color, life: 0.22, max: 0.22, rot: Math.random() }),
  ring: (list, x, y, color, size = 40) => list.push({ k: "ring", x, y, color, size, life: 0.35, max: 0.35 }),
  dust: (list, x, y, n = 5) => { for (let i = 0; i < n; i++) list.push({ k: "dust", x: x + rnd(-8, 8), y, vx: rnd(-60, 60), vy: rnd(-30, -5), s: rnd(3, 6), life: 0.4, max: 0.4 }); },
  glint: (list, x, y, n = 4) => { for (let i = 0; i < n; i++) list.push({ k: "glint", x: x + rnd(-14, 14), y: y + rnd(-10, 6), vy: rnd(-50, -20), s: rnd(2.5, 4.5), life: 0.6, max: 0.6 }); },
};

export const updateFx = (list, dt) => list.filter((f) => {
  f.life -= dt;
  if (f.vx) f.x += f.vx * dt;
  if (f.vy) f.y += f.vy * dt;
  return f.life > 0;
});

const star = (c, x, y, r, rot) => {
  c.beginPath();
  for (let i = 0; i < 8; i++) { const a = rot + (i * Math.PI) / 4, rad = i % 2 ? r * 0.3 : r; c.lineTo(x + Math.cos(a) * rad, y + Math.sin(a) * rad); }
  c.closePath(); c.fill();
};

export const drawFx = (c, list) => {
  list.forEach((f) => {
    const k = 1 - f.life / f.max;
    c.globalAlpha = Math.max(0, 1 - k);
    if (f.k === "spark") {
      c.fillStyle = f.color; star(c, f.x, f.y, 6 + k * 14, f.rot);
      c.fillStyle = "#FFFFFF"; star(c, f.x, f.y, 3 + k * 6, f.rot + 0.4);
    } else if (f.k === "ring") {
      c.strokeStyle = f.color; c.lineWidth = 5 * (1 - k) + 1;
      c.beginPath(); c.arc(f.x, f.y, 4 + f.size * k, 0, Math.PI * 2); c.stroke();
    } else if (f.k === "dust") {
      c.fillStyle = "rgba(255,248,231,0.75)"; c.beginPath(); c.arc(f.x, f.y, f.s * (1 + k), 0, Math.PI * 2); c.fill();
    } else {
      c.fillStyle = "#FFF3B0"; star(c, f.x, f.y, f.s, 0);
    }
  });
  c.globalAlpha = 1;
};

let vig = null;
export const drawVignette = (c, W, H) => {
  if (!vig || vig.c !== c) {
    const g = c.createRadialGradient(W / 2, H / 2, H * 0.45, W / 2, H / 2, H * 0.95);
    g.addColorStop(0, "rgba(0,0,0,0)"); g.addColorStop(1, "rgba(20,8,2,0.38)");
    vig = { c, g };
  }
  c.fillStyle = vig.g; c.fillRect(0, 0, W, H);
};

export const drawFade = (c, W, H, a) => { if (a <= 0) return; c.fillStyle = `rgba(12,6,2,${Math.min(1, a)})`; c.fillRect(0, 0, W, H); };
